// Source: app/scripts/controllers/user.js
/**
 * Created by ristes on 20.4.15.
 */



Auction.controller('UserController', [
  '$scope',
  '$filter',
  '$modal',
  'toaster',
  'crudService',
  'ngTableParams',
  'UserService',
  'EntityLogHelpers',
  function ($scope, $filter, $modal, toaster, crudService, ngTableParams, UserService, EntityLogHelpers) {

    var User = crudService('users', {
      enable: {
        method: 'POST',
        url: "/data/rest/registered_users/enable"
      },
      disable: {
        method: 'POST',
        url: "/data/rest/registered_users/disable"
      }
    });


    $scope.disableEntity = {};
    $scope.modalDisable = $modal({
      scope: $scope,
      template: 'forms/modals/disable.html',
      show: false
    });

    $scope.disable = function () {
      User.disable({
        username: $scope.disableEntity.username,
        days: $scope.disableEntity.days
      }, function () {
        $scope.modalDisable.hide();
        delete $scope.disableEntity.days;
        $scope.usersCrud.reload();
        $scope.usersCrud.edit($scope.disableEntity.id);
        $scope.disableEntity = {};
      });
    }

    $scope.actions = [{
      text: 'eauction.enable',
      name: 'enable',
      position: 'right',
      classes: 'btn btn-primary',
      iconClass: 'fa fa-fw fa-toggle-on',
      enabled: false,
      onClick: function (entity) {
        User.enable({
          username: entity.username
        }, function () {
          $scope.usersCrud.edit(entity.id);
        });
      }
    }, {
      text: 'eauction.disable',
      name: 'disable',
      position: 'right',
      classes: 'btn btn-primary',
      iconClass: 'fa fa-fw fa-toggle-off',
      enabled: false,
      onClick: function (entity) {
        $scope.disableEntity = entity;
        $scope.modalDisable.$promise.then($scope.modalDisable.show);
      }
    }];

    $scope.saveEmployee = function () {
      User.save($scope.user).$promise.then(function (data) {
      });

    };

    $scope.changeEmployee = function (_scope, user) {
      $scope.user = user;
    };


    $scope.onSelect = function (crudScope, entity) {
      crudScope.log = UserService.getLog({
        code: entity.username
      });
      EntityLogHelpers.attachLogFilters(crudScope);
    };

    $scope.afterInit = function (crudScope) {
      crudScope.resetUserMfaForRow = function (entity) {
        EntityLogHelpers.resetUserMfaForEntity(entity, UserService.resetUserMfa, toaster);
      };
    };
  }
]);
